// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"678":"633ec6443ae0606f4caf","731":"d514c11a3e170a503556","843":"ec4302638027797cca24"}[chunkId] + ".js";
};